import { Spin } from "antd"
import type { SpinIndicator } from "antd/es/spin"
import classNames from "classnames"
import type { ReactElement, ReactNode } from "react"

import "./Loading.less"

interface LoadingProps {
  className?: string
  display?: "block" | "inline"
  size?: "small" | "default" | "large"
  isFullPage?: boolean
  children?: ReactNode
  indicator?: SpinIndicator
}

export function Loading({
  className,
  display = "block",
  size,
  isFullPage = false,
  children,
  indicator,
}: LoadingProps): ReactElement | null {
  return (
    <div
      className={classNames("Loading", className, {
        "Loading__full-page": isFullPage,
        Loading__inline: display === "inline",
      })}
    >
      <Spin size={size} indicator={indicator} />
      {children && <div className="label">{children}</div>}
    </div>
  )
}
